import type { CalendarDesign } from "#internal"

import { CalendarMonthAreas } from "../CalendarMonthAreas"
import { PictureCover } from "../PictureCover"

/** Kebby, a wall calendar: the year low on its picture; a month under its picture, its name over its grid, the months either side small left of it, the contact under. */
export const Kebby: CalendarDesign = {
  cover: PictureCover({ at: 0.18 }),
  page: (boxes, month) => CalendarMonthAreas(boxes, month, true),
  pages: "month",
}
